import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RamsLanding from '../RamsLanding';
import RamsTemplatesPage from '../RamsTemplatesPage';
import RamsDocumentsPage from '../RamsDocumentsPage';
import RamsSitesPage from '../RamsSitesPage';
import RamsSettingsPage from '../RamsSettingsPage';

const RamsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<RamsLanding />} />
      <Route path="templates" element={<RamsTemplatesPage />} />
      <Route path="documents" element={<RamsDocumentsPage />} />
      <Route path="sites" element={<RamsSitesPage />} />
      <Route path="settings" element={<RamsSettingsPage />} />
    </Routes>
  );
};

export default RamsRoutes;
